import API from "../../..";
import { fullUrl } from '../../../utile/utile.api';

/* 物理削除可能な物件件数取得 */
type DeletablePropertyCountResponse = {
  /** ○	物理削除可能な物件の件数 */
  count: number,
}

const path = '/delete-count';

const deleteCount = (url: string) => () => {
  const full = fullUrl(url, path);
  return ({
    get: () => API.con.get<{}, DeletablePropertyCountResponse>({ url: full, data: {} }),
  })
}

export default deleteCount;
